import {FC, ReactElement, useState} from 'react';
import Tab, {TabProps} from './Tab';
import styled from 'styled-components';
import useLocalStorage from '../hooks/useLocalStorage';

const TabsContainer = styled.div<{ $centerOnMobile: boolean }>`
    @media (max-width: 768px) {
        && {
            flex-wrap: wrap;
            justify-content: ${props => props.$centerOnMobile ? 'center' : 'flex-start'};
        }
    }
`;

type TProps = {
    id: string;
    className?: string;
    children: ReactElement<TabProps, typeof Tab>[];
    defaultIndex?: number;
    itemClasses?: string;
    activeItemClasses?: string;
    centerOnMobile?: boolean;
}

const Tabs: FC<TProps> = ({id, className, children, defaultIndex = 0, activeItemClasses, itemClasses, centerOnMobile = false}) => {
    // const [activeTabIndex, setActiveTabIndex] = useLocalStorage<number>(`tabs/${id}`, defaultIndex);
    const [activeTabIndex, setActiveTabIndex] = useState<number>(defaultIndex);

    const enabledChildren = children.filter(child =>
        child.props.isEnabled ?? true
    );

    return (
        <>
            <TabsContainer $centerOnMobile={centerOnMobile} className={`cr-tabs cr-flex cr-gap cr-center ${className}`}>
                {enabledChildren.map((child, index) => {
                    return (
                        <button
                            key={index}
                            className={`${(index === activeTabIndex)
                                ? `cr-active ${activeItemClasses}`
                                : itemClasses
                            } cr-tab cr-pill cr-text-base`}
                            onClick={() => setActiveTabIndex(index)}>
                            {child.props.label}
                        </button>
                    );
                })}
            </TabsContainer>
            {enabledChildren[activeTabIndex]}
        </>
    );
};

export default Tabs;
